export const toggleElement = (button, toggle) => {
  if (!button) return;
  if (toggle) {
    button.classList.remove('hide');
    button.classList.remove('disabled');
  } else {
    button.classList.add('hide');
    button.classList.add('disabled');
  }
  button.disabled = !toggle;
}